var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{directives:[{name:"dialogDrag",rawName:"v-dialogDrag"}],attrs:{"title":_vm.ruleForm.name,"visible":_vm.dialogVisible,"width":"70%","top":"200px","modal-append-to-body":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.ruleForm.describe)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }